// extracted by mini-css-extract-plugin
export default {"formErrorError":"LoginScreen_formErrorError__yMiXr","login":"LoginScreen_login__v8YnT"};